module.exports = __webpack_public_path__ + "f32386d8f8c9f1c714f82b76172ca4d9.svg";